var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"ma-12"},[_vm._v(_vm._s(_vm.$translate("Oops! The page you're looking for does not exist")))])])}
var staticRenderFns = []

export { render, staticRenderFns }